import { Grid } from "@mui/material";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../../StateManagement/actions";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import WSDataGridNew from "../../../Components/DataGrid/WSDataGridNew";
import WSButton from "../../../Components/Button/WSButton";
import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
import AddIcon from '@mui/icons-material/Add';
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";

export const DoctorServiceList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const { add, edit, remove } = getPermissions("doctorService"); // role permissions for this page
const filters = ['All Records'];
       const [selectedFilter, setSelectedFilter] = useState(filters[0]);

        const [productSource, setProductSource] = useState<any>({
               url: "DoctorService/search",
               page: 1,
               pageSize: 10,
               filter: [
               ],
               sort: [
                 
               ],
           })
  const source = {
    url: "DoctorService/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  };

  useEffect(()=>{
          updateMainHeader('Doctor Service ');
        })

         breadCrumbsStore.updateBreadCrumbs([
                                { 'Doctor Service List': '/doctor-service/list' },
                  
                            ]);

  /**
   *  Edit function
   * @param action
   * @param row
   */
  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/doctor-service/edit/${row?.id}`);
    }

    if (action === "Delete") {
      setSelectedId(row.id); // Set the ID of the row to be deleted
      setPopupOpen(true);
    }
  };

  const handleFilter = (value: any) => {
        let soureFilter: any = {
            url: "DoctorService/search",
            page: 1,
            pageSize: 10,
            filter: [
            ],
            sort: [
                {
                    "field": "UpdatedAt",
                    "direction": "desc"
                }
            ],
        }
        switch (value) {
            case 'In Stock':
                soureFilter.filter = [{
                    "field": "name",
                    "operator": "eq",
                    "value": "In Stock"
                }]
                break

        }
      //  setProductSource({ ...soureFilter });
      }

  const columns: IColumns[] = [
    {
      header: "Service Name",
      fieldName: "serviceName",
      tooltip: true,
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit && "Edit", remove && "Delete"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
    },
  ];

  const handleClick = () => {
    navigate("/doctor-service/create");
  };

  const handleDelete = (response: any) => {
    dispatch(resetDataComponent("doctorserviceGrid"));
    showMessage("Doctor service successfully!", "success");
  };

  return (
    <Grid p={3}>
      {/* <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="doctorserviceGrid"
            title="Doctor Service"
            columns={columns}
            source={source}
            addButton={add ? { label: "New", color: "secondary" } : undefined}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
          {selectedId !== null && (
            <ConfirmationPopup
             type="DELETE"
              apiUrl={"DoctorService"}
              id={selectedId}
              confirmMessage="Are you sure you want to delete this item?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleDelete}
            />
          )}
        </Grid>
      </Grid> */}
 <Grid container spacing={2}>
             <Grid item sm={9}>
                    <WSFilterButtonGroup options={filters} selected={selectedFilter}
                        onChange={(value) => {
                            setSelectedFilter(value);
                            handleFilter(value);
                        }} />
                </Grid>
         <Grid item sm={3} display="flex" justifyContent={'flex-end'}>
                    {add && <WSButton id="btnAddNewProduct" label="Add Doctor Service" startIcon={<AddIcon />} 
                    onClick={handleClick}
                    sx={{
                        borderRadius: '999px',         // pill shape
                        backgroundColor: '#098963!important',    // green background
                        textTransform: 'none',         // prevent uppercase
                        fontWeight: 500,
                        height: '35px!important',
                        fontSize: '0.875rem!important',
                        paddingX: 3,
                        paddingY: 1,
                        '&:hover': {
                            backgroundColor: '#087654!important',
                        },
                    }} />}
                </Grid>
        <Grid item xs={12}>
         {productSource&& <WSDataGridNew
            id="doctorserviceGrid"
            title="Doctor Service"
            columns={columns}
            source={productSource}
             searchBox={{ fieldName: 'serviceName' }}
            addButton={add ? { label: "New", color: "secondary" } : undefined}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
}
         {selectedId !== null && (
            <ConfirmationPopup
             type="DELETE"
              apiUrl={"DoctorService"}
              id={selectedId}
              confirmMessage="Are you sure you want to delete this item?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleDelete}
            />
          )}
        </Grid>
      </Grid>


    </Grid>
  );
});
